import React, { useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/store";
import KycDetails from "./KycDetails";
import KycForm from "./KycForm";
import { Card } from "antd";
import Loader from "../../../../components/Loader";

const KycContainer: React.FC = () => {
  const user = useSelector((state: RootState) => state.user);
  const [editMode, setEditMode] = useState(false);

  // Check if user has completed KYC
  const kycData = user?.pendingKycRequest;
  const isKycApproved = kycData?.status === "approved";

  const handleEditKyc = () => {
    setEditMode(true);
  };

  const handleCancelEdit = () => {
    setEditMode(false);
  };

  const handleResubmitKyc = () => {
    setEditMode(true);
  };

  if (!user) {
    return <Loader />;
  }

  // If KYC is approved and not in edit mode, show details
  if (isKycApproved && !editMode) {
    return (
      <KycDetails
        kycData={kycData}
        onEdit={handleEditKyc}
        onResubmit={handleResubmitKyc}
      />
    );
  }

  // If KYC is not approved or in edit mode, show form
  return (
    <Card title="KYC Verification" className="my-6 shadow-md">
      <KycForm isEditMode={editMode} onCancel={handleCancelEdit} />
    </Card>
  );
};

export default KycContainer;
